/* unplugin-vue-components disabled */import { render } from "./democracy.vue?vue&type=template&id=74902a52&scoped=true&ts=true"
import script from "./democracy.vue?vue&type=script&lang=ts"
export * from "./democracy.vue?vue&type=script&lang=ts"

import "./democracy.vue?vue&type=style&index=0&id=74902a52&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74902a52"]])

export default __exports__